export const events = {
    NODOS:'nodos',
    CARRUSELES:'carruseles',
    MENU:'menú segundo nivel',
    CARDMATCH:'tarjetas de partidos',
    VCARDMATCH:'vcard partidos',
    VCARDTEAM:'vcard de equipo',
    VCARDPLAYER:'vcard jugador',
    PLAYER:'reproductor',
}

export const category = {
    NODO:'top menu',
    CARRUSELES:'carruseles inicio',
    MENU:'mundial 2022',
    VCARD:'carruseles vcard',
    VCARDPLAYER:'jugadores relacionados',
    PLAYER:'reproductor',
}

export const Actions = {
    NODO:'click',
    SUPERDESTACADO:'superdestacados',
    CARDMATCH:'minuto a minuto',
    WORDCUP:'mundial 2022',
    LOGO:'logo',
    BUTTOM:'buttom group',
    MATCH:'partidos',
    CALENDAR:'calendario',
    GRUOUP:'grupos',
    SELECCIONADO:'seleccionados',
    JUGADOR:'seleccionados relacionados',
    NATIONAL:'selecciones'

}

